import type { AidPreferenceDto } from "../../types/AidPreferenceDto";
import type { AidPreferenceEntity } from "../../types/AidPreferenceEntity";

export const AidPreferenceDtoToEntity = ({ ...rest }: Readonly<AidPreferenceDto>): AidPreferenceEntity => {
    return { ...rest };
};
